export default __webpack_public_path__ + "static/FOX-4ccea53c6e1815adc777316b933e4f97.svg";